import React, { useMemo } from 'react';
import classNames from 'classnames';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { Alignment } from 'models/Global';
import FileSecurityLevels from './components/FileSecurityLevels';
import DefaultsSettingsTag from 'router/subrouters/DataRoom/components/DefaultsSettingsTag';
import WarningBanner from 'components/WarningBanner';
import { SHOW_MAXIMUM_SECURITY } from 'router/subrouters/DataRoom/providers/DesktopApp/DesktopApp.provider';

import './FileSecurity.styles.scss';

type FileSecurityProps = {
  className?: string;
  defaultOpen?: boolean;
  showDefaultsSettingsSetup?: boolean;
  defaultsSettingsSetupAt?: Date;
  defaultsSettingsSetupBy?: { firstName: string; lastName?: string };
  levelsLayout?: Alignment;
  fileSecurityWarning?: string;
  isDisabled?: boolean;
  collapsible?: boolean;
  title?: string;
};

const FileSecurity: React.FC<FileSecurityProps> = (props) => {
  const {
    children,
    className,
    defaultsSettingsSetupAt,
    defaultsSettingsSetupBy,
    levelsLayout,
    fileSecurityWarning,
    isDisabled,
    title,
    showDefaultsSettingsSetup = false,
    defaultOpen = true,
    collapsible = true,
  } = props;

  const classes = classNames('file-security', 'white-panel', className);

  const triggerContent = useMemo(
    () =>
      (title || showDefaultsSettingsSetup) && (
        <div className="trigger__content">
          {title && <p className="name">{title}</p>}

          {showDefaultsSettingsSetup && (
            <DefaultsSettingsTag
              defaultsSettingsSetupAt={defaultsSettingsSetupAt}
              defaultsSettingsSetupBy={defaultsSettingsSetupBy}
            />
          )}
        </div>
      ),
    [
      defaultsSettingsSetupAt,
      defaultsSettingsSetupBy,
      showDefaultsSettingsSetup,
      title,
    ],
  );

  const content = useMemo(
    () => (
      <>
        {fileSecurityWarning && <WarningBanner title={fileSecurityWarning} />}

        <FileSecurityLevels
          className="file-security__settings"
          layout={levelsLayout}
          maximumSecurityComingSoon={!SHOW_MAXIMUM_SECURITY}
          isDisabled={isDisabled}
        />

        {children}
      </>
    ),
    [children, levelsLayout, fileSecurityWarning, isDisabled],
  );

  if (!collapsible) {
    return (
      <div className={classes}>
        {triggerContent}
        {content}
      </div>
    );
  }

  return (
    <CollapsibleSection
      className={classes}
      defaultOpen={defaultOpen}
      trigger={triggerContent}
    >
      {content}
    </CollapsibleSection>
  );
};

export default FileSecurity;
